// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Preloader_preloader__3UvLq"};